import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import  {AdTypes,
  AdAssetTypes,
  AdTypeGroups,
  AdTypeOwners,
} from "./TagPageContents";

export default function NewAddType() {
  const tabStyle = {
    fontSize: "0.80rem",
    marginTop: "1rem",
  };
  const tableSize = {
    width: "100%",
    margin: "0 auto",
    padding: "auto 1rem",
  };

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1", display: "flex" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} orientation="vertical">
            <Tab label="AD TYPES" value="1" style={tabStyle} />
            <Tab label="AD TYPE GROUPS" value="2" style={tabStyle} />
            <Tab label="AD ASSET TYPES" value="3" style={tabStyle} />
            <Tab label="AD TYPE OWNERS" value="4" style={tabStyle} />
          </TabList>
        </Box>
        <TabPanel value="1" style={tableSize}>
          <AdTypes />
        </TabPanel>
        <TabPanel value="2" style={tableSize}>
          <AdTypeGroups />
        </TabPanel>
        <TabPanel value="3" style={tableSize}>
          <AdAssetTypes />
        </TabPanel>
        <TabPanel value="4" style={tableSize}>
          <AdTypeOwners />
        </TabPanel>
      </TabContext>
    </Box>
  );
}
